'use strict';

function Search() {
  // Do some fancy stuff to the the search form
  var $text_field = $('.region-header .block-aciar-cross-site-search .form-text');
  var $submit_button = $('.region-header .block-aciar-cross-site-search .form-actions input');
  var $search_form = $('.region-header .block-aciar-cross-site-search form');
  var $menu = $('.region-header #block-mainnavigation');
  var $logo = $('.region-header #block-websitelogo');
  $text_field.attr('tabindex', -1);
  $text_field.attr('placeholder', 'Type here...');
  $submit_button.attr('tabindex', 1); // Make sure the header search form has something in it
  $search_form.submit(function () {
    if (typeof $text_field.val() !== 'undefined' && $text_field.val() !== '' && $text_field.width() > 10) {
      return true;
    } else {
      if ($submit_button.hasClass('active') && $text_field.val() == '') {
        $text_field.removeClass('active');
        $submit_button.removeClass('active');
        $logo.removeClass('active');
        $text_field.blur();
        $menu.removeClass('hide');
      } else {
        $text_field.addClass('active');
        $submit_button.addClass('active');
        $logo.addClass('active');
        $text_field.focus();
        $menu.addClass('hide');
      }
      return false;
    }
  }); // When the form loses focus

  $('body').on('click', function (e) {
    var $eTarget = $(e.target);
    if (!$eTarget.parents('.block-aciar-cross-site-search').length && $text_field.val() == '') {
      $text_field.removeClass('active');
      $submit_button.removeClass('active');
      $logo.removeClass('active');
      $menu.removeClass('hide');
    }
  });
};

export default Search;
